
import React from 'react';

import { Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    spinner: {
        color: 'white',
    },
    message: {
        color: 'white',
        marginTop: theme.spacing(2),
    },
}));

function FullScreenLoading() {
    const classes = useStyles();
    return (
        <Box className={classes.overlay}>
            <CircularProgress size={60} className={classes.spinner} />
            <Typography variant="h6" className={classes.message}>
                Đang xử lý, vui lòng chờ...
            </Typography>
        </Box>
    );
}

export default FullScreenLoading;
